import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Progress of the manual sign-up: numbered steps joined by a line that fills in as the candidate advances.
 * Done steps show a tick and can be clicked to go back; the current one is highlighted; the next ones are grey.
 */
@Component({
  selector: 'app-flow-stepper',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './flow-stepper.component.html',
  styleUrl: './flow-stepper.component.scss'
})
export class FlowStepperComponent {
  /** Current step, starting at 1 */
  @Input() current = 1;

  /** Translation keys of the step names, in order */
  @Input() steps: string[] = [
    'register.steps.personalData',
    'register.steps.experience',
    'register.steps.education',
    'register.steps.skills',
    'register.steps.preferences',
  ];

  /** A completed step was clicked (to go back to it) */
  @Output() stepSelect = new EventEmitter<number>();

  select(step: number) {
    if (step < this.current) {
      this.stepSelect.emit(step);
    }
  }
}
